import palette from '../palette';

export default {
  root: {
    '&$selected': {
      backgroundColor: palette.list.selected,
    },
  },
};
